import OptimizerEditDto from "./OptimizerEditDto";

export class BayesianOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.initialPoint = null;
        /** @type {number} */
        this.iterations = null;
        /** @type {number} */
        this.verbose = null;
        /** @type {number} */
        this.randomState = null;
    }

    /**
     * @typedef {Object} _BayesianOptimizerEditDtoProps
     * @property {number} initialPoint
     * @property {number} iterations
     * @property {number} verbose
     * @property {number} randomState
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _BayesianOptimizerEditDtoProps} BayesianOptimizerEditDtoProps
     */
    /**
     * 
     * @param {BayesianOptimizerEditDtoProps} props
     * @returns {BayesianOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.initialPoint = props.initialPoint;
        this.iterations = props.iterations;
        this.verbose = props.verbose;
        this.randomState = props.randomState;
        return this;
    }
}

export default BayesianOptimizerEditDto;